export type Locale = 'de' | 'en';

export const LOCALES: Locale[] = ['de', 'en'];

export type Messages = {
  common: {
    loading: string;
    save: string;
    saving: string;
    cancel: string;
    close: string;
    delete: string;
    apply: string;
    reset: string;
    yes: string;
    no: string;
    open: string;
    ptSuffix: string;
    itemsSuffix: string;
  };
  appBar: {
    title: string;
    importCsv: string;
    releaseCalendar: string;
    capacity: string;
    backup: string;
    clearAll: string;
    themeLight: string;
    themeDark: string;
    account: string;
    switchLanguage: string;
    profile: string;
    logout: string;
    roleAdmin: string;
    roleUser: string;
    confirmClearAll: string;
  };
  sections: Record<
    | 'filters' | 'stats' | 'status' | 'timeline' | 'trend' | 'columns'
    | 'funnel' | 'outliers' | 'duplicates' | 'burnup' | 'drift' | 'epics'
    | 'deps' | 'customerBugs' | 'releaseTickets' | 'sprint' | 'expectedBehaviour' | 'checklist' | 'search' | 'clusters',
    { title: string; subtitle: string }
  >;
  login: {
    title: string;
    subtitle: string;
    username: string;
    password: string;
    submit: string;
    submitting: string;
    errorFallback: string;
  };
  filters: {
    searchPlaceholder: string;
    status: string;
    assignee: string;
    priority: string;
    reset: string;
  };
  teamBar: {
    label: string;
    allTeams: string;
    otherTeams: string;
    spToPtLabel: string;
  };
  stats: {
    epics: string;
    stories: string;
    bugs: string;
  };
  statusBreakdown: {
    title: string;
    subtitle: string;
  };
  banner: {
    noSnapshotTitle: string;
    noSnapshotBody: string;
    filteredTitle: string;
    loadedTitle: string;
    issues: string;
    teamPrefix: string;
    statusPrefix: string;
    assigneePrefix: string;
    priorityPrefix: string;
    searchPrefix: string;
    mergedCsvs: string;
    importedAt: string;
    hideExportNote: string;
    showExportNote: string;
    exportConvTitle: string;
    exportConvBody: string;
    exportConvJql: string;
    exportConvHint: string;
  };
  import: {
    title: string;
    dropzone: string;
    dropzoneHint: string;
    modeQuestion: string;
    modeReplace: string;
    modeReplaceHint: string;
    modeMerge: string;
    modeMergeHint: string;
    close: string;
    importBtn: string;
    importing: string;
    verbReplaced: string;
    verbMerged: string;
    resultTemplate: string;
  };
  releaseCal: {
    title: string;
    subtitle: string;
    empty: string;
    delRelease: string;
    startLabel: string;
    endLabel: string;
    servicePacks: string;
    addSp: string;
    removeSp: string;
    releaseNamePh: string;
    addRelease: string;
    confirmDelete: string;
    errNeedDates: string;
    errStartAfterEnd: string;
    errSpMissing: string;
  };
  capacity: {
    title: string;
    subtitle: string;
    quickFill: string;
    apply: string;
    manual: string;
    auto: string;
    save: string;
    saving: string;
    close: string;
    teamLabel: string;
    releaseLabel: string;
    noTeams: string;
    pickTeamHint: string;
    monthHeader: string;
    storiesLabel: string;
    bugsLabel: string;
    sumFor: string;
    storiesChip: string;
    bugsChip: string;
    totalChip: string;
    fillStories: string;
    fillBugs: string;
    fillBoth: string;
  };
  backup: {
    title: string;
    subtitle: string;
    exportCardTitle: string;
    exportCardBody: string;
    countIssues: string;
    countReleases: string;
    countTeamsCapa: string;
    countInitialPlans: string;
    download: string;
    restoreCardTitle: string;
    restoreCardBody: string;
    dropzone: string;
    dropzoneHint: string;
    fileMeta: string;
    modeQuestion: string;
    modeReplace: string;
    modeReplaceHint: string;
    modeMerge: string;
    modeMergeHint: string;
    close: string;
    replace: string;
    merge: string;
    restoring: string;
    restoreOk: string;
  };
  releaseBlocks: {
    title: string;
    subtitle: string;
    releaseCalBtn: string;
    capacityBtn: string;
    noDateSet: string;
    itemsSummary: string;
    planChip: string;
    actualChip: string;
    capacityChip: string;
    noCapacityChip: string;
  };
  epicDrift: {
    tooltipHead: string;
    empty: string;
    driftExplain: string;
    epicsOtherRelease: string;
    confExplain: string;
  };
  epicsTable: {
    title: string;
    subtitle: string;
    expandAll: string;
    collapseAll: string;
    colType: string;
    colKey: string;
    colSummary: string;
    colStatus: string;
    colAssignee: string;
    colTeam: string;
    priority: string;
    colRough: string;
    colSp: string;
    colEstimate: string;
    colPlan: string;
    colActual: string;
    colKids: string;
  };
  outliers: {
    title: string;
    explain: string;
    itemsOverThreshold: string;
    emptyState: string;
    emptyStateTeam: string;
    subTaskAggregate: string;
    sumRawPT: string;
    cappedRemoved: string;
  };
  trend: {
    storiesTip1: string;
    storiesTip2: string;
    storiesTip3: string;
    bugsTip1: string;
    bugsTip2: string;
    priorityChip: string;
    deltaPctLabel: string;
    closedDefinition: string;
    createdLegend: string;
    closedLegend: string;
    sumCreated: string;
    sumClosed: string;
    deltaTotal: string;
    infoTextStories: string;
    infoTextBugs: string;
    footerReading: string;
    footerBars: string;
    footerTeamFiltered: string;
    footerAllTeams: string;
    barCreated: string;
    barClosed: string;
    allTeamsChip: string;
  };
  funnel: {
    capacity: string;
    capacityDesc: string;
    roughPlanning: string;
    roughPlanningDesc: string;
    refinedFull: string;
    refinedFullDesc: string;
    noLogBackground: string;
    outlierCapTip: string;
    releaseCompleted: string;
    releasePastDue: string;
    perReleaseInfo: string;
    noCapacityLeg: string;
    capacityUnused: string;
    capacityOverbudget: string;
    realityExceedsRough: string;
    perItemHigherThanDetail: string;
    barScaleInfo: string;
    dataQualityLow: string;
    whatCounts: string;
    roughOverCapa: string;
    detailOverRough: string;
    actualOverPlan: string;
    realismCheck: string;
  };
  months: string[];
  health: {
    unknown: {
      headline: string;
      detail: string;
    };
    completed: {
      headline: string;
      detail: string;
    };
    expiredOpen: {
      headline: string;
      detail: string;
    };
    pastDue: {
      headline: string;
      detail: string;
    };
    noCapacity: {
      headline: string;
      detail: string;
    };
    breeze: {
      headline: string;
      detail: string;
    };
    doable: {
      headline: string;
      detail: string;
    };
    tight: {
      headline: string;
      detail: string;
    };
    unrealistic: {
      headline: string;
      detail: string;
    };
  };
  cols: {
    kapa: string;
    initial: string;
    kapaSlashInitial: string;
    grob: string;
    refine: string;
    ist: string;
    factorNote: string;
    tipKapa: string;
    tipInitial: string;
    tipKapaPlan: string;
    tipEpicGrob: string;
    tipEpicGrobDate: string;
    nRefSkippedNote: string;
    refCapNote: string;
    refCapNoteNone: string;
    tipRefineStart: string;
    tipRefineSource: string;
    tipRefineStatus: string;
    tipRefineTotal: string;
    tipRefineStoriesCount: string;
    tipRefineBugsCount: string;
    tipRefineReadHelp: string;
    istTimeWindowText: string;
    istTimeWindowNone: string;
    skippedNote: string;
    noPlanNote: string;
    istCapNote: string;
    istCapNoteNone: string;
    tipIstStart: string;
    tipIstSource: string;
    tipIstStoriesCount: string;
    tipIstBugsCount: string;
    tipIstRelation: string;
    tipIstVsKapa: string;
    tipIstVsRough: string;
    tipIstVsDetail: string;
    tipIstReadHelp: string;
    refWarn: string;
    istWarn: string;
    kapaDetail1: string;
    kapaDetail2: string;
    initialDetail1: string;
    initialDetail2: string;
    grobDetail1: string;
    grobDetail2: string;
    grobDetail3: string;
    grobDetail4: string;
    refineDetail1: string;
    refineDetail2: string;
    refineDetail3: string;
    refineDetail4: string;
    refineDetail5: string;
    refineDetail6: string;
    refineDetail7: string;
    istDetail1: string;
    istDetail2: string;
    istDetail3: string;
    istDetail4: string;
    istDetail5: string;
    istDetail6: string;
    subLabelEpicsMixed: string;
    subLabelResolved: string;
    subLabelResolvedItems: string;
    subLabelClosed: string;
    subLabelNoEstimate: string;
  };
};

export const messages: Record<Locale, Messages> = {
  de: {
    common: {
      loading: 'Lade …',
      save: 'Speichern',
      saving: 'Speichere …',
      cancel: 'Abbrechen',
      close: 'Schließen',
      delete: 'Löschen',
      apply: 'Anwenden',
      reset: 'Zurücksetzen',
      yes: 'Ja',
      no: 'Nein',
      open: 'Öffnen',
      ptSuffix: 'PT',
      itemsSuffix: 'Items',
    },
    appBar: {
      title: 'SchueCal Dashboard',
      importCsv: 'CSV importieren',
      releaseCalendar: 'Release-Kalender bearbeiten',
      capacity: 'Kapazität pflegen',
      backup: 'Backup & Restore',
      clearAll: 'Alle Issues löschen',
      themeLight: 'Helles Theme',
      themeDark: 'Dunkles Theme',
      account: 'Account',
      switchLanguage: 'Sprache: Deutsch',
      profile: 'Profil (kommt später)',
      logout: 'Abmelden',
      roleAdmin: 'Administrator',
      roleUser: 'Benutzer',
      confirmClearAll:
        'Wirklich alle geladenen Issues und Meta-Daten löschen? Kapazität, Release-Kalender etc. bleiben erhalten.',
    },
    sections: {
      filters: {
        title: 'Team-Filter & SP→PT-Faktor',
        subtitle:
          'Globaler Team-Filter (wirkt auf alle Karten unten) und Story-Points-Umrechner. Aktuell: SP wird nicht in die Berechnung einbezogen.',
      },
      stats: {
        title: 'Counts: Epics · Stories · Bugs',
        subtitle:
          'Anzahl der Issue-Typen nach den aktuellen Filtern. Reagiert auf Team und globale Filter.',
      },
      status: {
        title: 'Status-Verteilung',
        subtitle:
          'JIRA-Workflow-Status der Stories und Bugs. Pflicht-Status werden immer gezeigt, auch wenn Count = 0.',
      },
      timeline: {
        title: 'Timeline & Release-Kalender',
        subtitle:
          '18-Monats-Achse mit Release-Bändern, Service-Pack-Phasen und SP-Markern. Created/Resolved-Trend pro Monat.',
      },
      trend: {
        title: 'Ticket-Trend (Stories + Bugs)',
        subtitle:
          'Zwei Charts pro Typ: Created vs. Resolved über die Monate, mit Δ%-Trendlinie. Filter-aware.',
      },
      columns: {
        title: 'Säulenplanung pro Release',
        subtitle:
          'Fünf Säulen: Kapazität → Initial-Plan → Grobplanung → Detailplanung → Ist Aufwand. Pflegbar via Modale.',
      },
      funnel: {
        title: 'Funnel + Realismus-Check',
        subtitle:
          'Pro Release: Plan-Trichter mit Δ-Annotations und Ampel-Bewertung (Restkapa vs. Restarbeit).',
      },
      outliers: {
        title: 'Daten-Qualität: unplausible Trackings',
        subtitle:
          'Stories/Bugs mit Estimate oder Σ Time Spent über 30 PT. In den Säulen werden diese Items auf 10 PT gekappt — die Tabelle zeigt die Originale für die JIRA-Pflege.',
      },
      duplicates: {
        title: 'Daten-Qualität: mögliche Duplikate',
        subtitle:
          'Lexikalisch ähnliche Stories/Bugs pro Team — offene Items + done der letzten 6 Monate. Pre-Filter: gleiches Team + Issue Type. Mit Direkt-Link in JIRA.',
      },
      burnup: {
        title: 'Refinement-Burn-Up (über Importe)',
        subtitle:
          'Linien-Chart über die History-Snapshots: Open/Closed-Counts, Closure-Rate, Plan-vs-Refined-Burn-Up. Mit Team-Selector.',
      },
      drift: {
        title: 'Epic-Drift & Confidence',
        subtitle:
          'Tabelle: pro Epic die Drift zwischen Grob und Refined, Refinement-Fortschritt, Confidence-Score. Sortierbar.',
      },
      epics: {
        title: 'Epics-Tabelle mit Child items',
        subtitle:
          'Alle Epics expandierbar mit Stories/Bugs. Plan-/Ist-Werte pro Item. Filter-aware.',
      },
      deps: {
        title: 'Ticket-Abhängigkeiten',
        subtitle:
          'Blockiert, blockiert von, verwandt — pro Ziel-Team aufgeschlüsselt. Priorität: Tools und Features. „is blocked by" ist die kritischste Klasse.',
      },
      customerBugs: {
        title: 'Bugs: Kunden vs. intern',
        subtitle:
          'Aufteilung der Bugs nach Herkunft. Kunden-Bug = Ticket mit CPS-Verknüpfung (Custom Field „CPS Ticket ID"). Intern = ohne CPS-Bezug.',
      },
      releaseTickets: {
        title: 'Tickets pro Release / Service Pack',
        subtitle:
          'Auswahl einer Fix-Version (z.B. „2026 R1 SP03") und Anzeige aller Tickets darin. Standard: nur geschlossene. Team-Filter oben wirkt zusätzlich.',
      },
      sprint: {
        title: 'Sprint-Auswertung',
        subtitle:
          'Zeitraum frei wählbar (Default 3 Wochen). Zählt Tickets, deren Status = done und deren Resolved-Datum im Zeitraum liegt. Breakdown nach Issue-Type, Team, CPS, Carry-Over.',
      },
      expectedBehaviour: {
        title: 'Expected Behaviour: Qualitätsübersicht',
        subtitle:
          'Ist das Feld überhaupt gefüllt? In welcher Sprache? Ausführlich oder zu knapp? Coverage pro Team und Issue-Type, Sprach-Verteilung, Qualitäts-Buckets nach Textlänge.',
      },
      checklist: {
        title: 'Checkliste / Acceptance Criteria',
        subtitle:
          'Wertet das JIRA-Feld „Checklist Text" aus: Coverage, „# Acceptance Criteria"-Header, erledigte vs. offene Items pro Ticket. Excel-Export mit JIRA-Links.',
      },
      search: {
        title: 'Volltextsuche über alle Tickets',
        subtitle:
          'Suche in Summary, Expected Behaviour, Parent Summary, Labels und mehr. Case-sensitive und Regex möglich. Kombinierbar mit Team-Filter und Status-Scope.',
      },
      clusters: {
        title: 'Cluster: Profile · Beschläge · Serien',
        subtitle:
          '3-stufige Klassifikation aus Labels (Klinkung/Verglasung/…) und Summary-Präfix (AWS 75, Janisol Arte 2.0, …). Ein Ticket kann in mehreren Clustern landen.',
      },
    },
    login: {
      title: 'SchueCal Dashboard',
      subtitle: 'Bitte anmelden',
      username: 'Benutzername',
      password: 'Passwort',
      submit: 'Anmelden',
      submitting: 'Anmelden …',
      errorFallback: 'Login fehlgeschlagen',
    },
    filters: {
      searchPlaceholder: 'Suche nach Key, Summary, Assignee, Team …',
      status: 'Status',
      assignee: 'Assignee',
      priority: 'Priorität',
      reset: 'Filter zurücksetzen',
    },
    teamBar: {
      label: 'Team-Filter',
      allTeams: 'Alle Teams ({count})',
      otherTeams: 'Weitere Teams',
      spToPtLabel: '1 SP =',
    },
    stats: {
      epics: 'Epics',
      stories: 'Stories',
      bugs: 'Bugs',
    },
    statusBreakdown: {
      title: 'Status-Verteilung',
      subtitle: '{count} Stories + Bugs nach JIRA-Workflow',
    },
    banner: {
      noSnapshotTitle: 'Kein JIRA-Snapshot geladen',
      noSnapshotBody:
        'Klicke oben rechts auf **CSV importieren** und lade einen JIRA-Export hoch. Mehrfachauswahl ist möglich — JIRAs 10.000-Issues-Export-Limit umgehen wir, indem du pro Team einzeln exportierst (siehe Export-Notiz nach dem Import).',
      filteredTitle: 'Gefilterte Sicht: {filtered} von {total} Issues',
      loadedTitle: 'JIRA-Snapshot geladen',
      issues: '{count} Issues',
      teamPrefix: 'Team',
      statusPrefix: 'Status',
      assigneePrefix: 'Assignee',
      priorityPrefix: 'Priorität',
      searchPrefix: 'Suche',
      mergedCsvs: '{count} CSVs gemerged',
      importedAt: 'Stand: {date}',
      hideExportNote: 'Export-Notiz ausblenden',
      showExportNote: 'Wie wurden die CSVs exportiert?',
      exportConvTitle: 'Export-Konvention — pro Team eine eigene CSV',
      exportConvBody:
        'JIRA erlaubt pro CSV-Export maximal **10.000 Issues**. Der gesamte SchueCal-Bestand liegt aktuell bei **{count}** Issues — also wird pro Team einzeln exportiert und beim Import hier zusammengemerged (Dedup nach `Issue key`).',
      exportConvJql: 'Pro Team: JQL-Filter + Export → CSV (All fields)',
      exportConvHint:
        '• **JIRA-UI**: Issues → Suche → JQL eingeben → *… (3-Punkt-Menü)* → **Export** → **CSV (All fields)**.\n• Pflicht-Spalten im Export: `Issue Type`, `Issue key`, `Summary`, `Status`, `Team Name`, `Parent key`, `Fix versions`, `Affects Version/s`, `Σ Original Estimate`, `Σ Time Spent`, `Custom field (Rough Estimation (d))`, `Created`, `Resolved`.\n• Mehrere Files im CSV-Import-Dialog gleichzeitig hochladen — die werden via `Issue key` dedupliziert. Doppelte Einträge (z.B. wenn ein Item in zwei Teams aufgeteilt erscheint) werden automatisch konsolidiert.',
    },
    import: {
      title: 'CSV importieren',
      dropzone: 'CSV-Dateien hier ablegen oder klicken',
      dropzoneHint: 'Mehrfachauswahl möglich · Dedup nach „Issue key"',
      modeQuestion: 'Wie verarbeiten?',
      modeReplace: 'Ersetzen (Empfohlen)',
      modeReplaceHint: 'Bestehende Issues durch die neuen ersetzen — sauberer Snapshot.',
      modeMerge: 'Hinzufügen / Mergen',
      modeMergeHint: 'Bestehende + neue mergen, gleiche Issue keys werden überschrieben (Team-Splits).',
      close: 'Schließen',
      importBtn: 'Importieren ({count})',
      importing: 'Importiere …',
      verbReplaced: 'ersetzt durch',
      verbMerged: 'zusammengeführt zu',
      resultTemplate: 'Issues {verb} {count} netto',
    },
    releaseCal: {
      title: 'Release-Kalender',
      subtitle: 'Start/Ende pro Release · Service Packs pro Release',
      empty: 'Noch keine Releases. Lege unten den ersten an.',
      delRelease: 'Release löschen',
      startLabel: 'Start',
      endLabel: 'Ende',
      servicePacks: 'Service Packs ({count})',
      addSp: 'SP hinzufügen',
      removeSp: 'SP entfernen',
      releaseNamePh: 'z.B. 2028 R1',
      addRelease: 'Release',
      confirmDelete: 'Release "{name}" wirklich löschen? Alle Service Packs werden ebenfalls entfernt.',
      errNeedDates: '"{name}" braucht Start- und End-Datum.',
      errStartAfterEnd: '"{name}": Start ({start}) liegt nach Ende ({end}).',
      errSpMissing: '"{name}" hat SP ohne Name oder Datum.',
    },
    capacity: {
      title: 'Kapazität verwalten',
      subtitle: 'Personentage pro Team × Release × Monat (getrennt Stories / Bugs)',
      quickFill: 'Schnellfüllen-Wert',
      apply: 'Anwenden',
      manual: 'Manuell',
      auto: 'Automatisch',
      save: 'Speichern',
      saving: 'Speichere …',
      close: 'Schließen',
      teamLabel: 'Team',
      releaseLabel: 'Release',
      noTeams: 'Keine Teams in den Daten',
      pickTeamHint: 'Wähle oben ein Team aus, um Kapazität zu pflegen.',
      monthHeader: 'Monat',
      storiesLabel: 'Stories',
      bugsLabel: 'Bugs',
      sumFor: 'Σ für {team} · {release}:',
      storiesChip: 'Stories {value} PT',
      bugsChip: 'Bugs {value} PT',
      totalChip: 'Gesamt {value} PT',
      fillStories: '→ Stories',
      fillBugs: '→ Bugs',
      fillBoth: '→ S+B',
    },
    backup: {
      title: 'Sicherung & Wiederherstellung',
      subtitle: 'JSON-Snapshot aller Daten · Stand auf einen anderen Rechner mitnehmen',
      exportCardTitle: 'Sichern',
      exportCardBody: 'Komplettes JSON-File mit allem aktuellen Stand (Issues + Konfiguration).',
      countIssues: '{count} Issues',
      countReleases: '{count} Release(s)',
      countTeamsCapa: '{count} Team(s) Kapa',
      countInitialPlans: '{count} Initial-Plan(s)',
      download: 'Backup herunterladen',
      restoreCardTitle: 'Wiederherstellen',
      restoreCardBody:
        'JSON-Backup hochladen. Du wirst gefragt, ob du den aktuellen Stand ersetzen oder mergen möchtest.',
      dropzone: 'JSON-Backup hier ablegen oder klicken',
      dropzoneHint: 'Nur eine Datei',
      fileMeta: '{size} · exportiert am {date}',
      modeQuestion: 'Wie verarbeiten?',
      modeReplace: 'Ersetzen (Empfohlen)',
      modeReplaceHint: 'Bestehende Daten verwerfen, Backup-Stand vollständig übernehmen.',
      modeMerge: 'Mergen',
      modeMergeHint:
        'Issues mergen (gleiche Issue keys werden überschrieben). Konfiguration ebenfalls mergen.',
      close: 'Schließen',
      replace: 'Ersetzen',
      merge: 'Mergen',
      restoring: 'Stelle wieder her …',
      restoreOk: 'Restore erfolgreich. {issues} Issues, {releases} Release(s) jetzt aktiv.',
    },
    releaseBlocks: {
      title: 'Säulenplanung',
      subtitle:
        '{count} Release(s) · Kapazität · Säulenplanung · Grobplanung · Detailplanung · Ist',
      releaseCalBtn: 'Release-Kalender',
      capacityBtn: 'Kapazität pflegen',
      noDateSet: 'Datum noch nicht gepflegt',
      itemsSummary: '{epics} Epic(s) · {stories} Stories · {bugs} Bugs',
      planChip: 'Plan {value} PT',
      actualChip: 'Ist {value} PT',
      capacityChip: 'Kapazität {value} · Auslastung {pct}%',
      noCapacityChip: 'Keine Kapazität gesetzt',
    },
    epicDrift: {
      tooltipHead:
        'Pro Epic: wie weit liegt die Detailplanung (Σ Original Estimate der Refinements) von der Grobplanung (Rough) ab?',
      empty: 'Keine Epics in dieser Auswahl. Filter weiter öffnen oder anderen Release wählen.',
      driftExplain:
        'Drift = Σ-refined-Child-items − Rough · zählt nur Child items, deren Fix Version zum gleichen Release gehört.',
      epicsOtherRelease:
        '{count} gefilterte Epics gehören zu einem anderen Release oder haben keine Release-Zuordnung.',
      confExplain:
        'Confidence = Mittelwert aus „% refined" und „% mit SP gepflegt". Sortiere absteigend, um Kandidaten fürs nächste Refinement zu finden.',
    },
    epicsTable: {
      title: 'Epics & Stories/Bugs',
      subtitle: '{epics} Epic(s) · {kids} Child items',
      expandAll: 'Alle ausklappen',
      collapseAll: 'Alle einklappen',
      colType: 'Typ',
      colKey: 'Key',
      colSummary: 'Summary',
      colStatus: 'Status',
      colAssignee: 'Assignee',
      colTeam: 'Team',
      priority: 'Priorität',
      colRough: 'Rough',
      colSp: 'SP',
      colEstimate: 'Estimate',
      colPlan: 'Plan (PT)',
      colActual: 'Ist (PT)',
      colKids: 'Child items',
    },
    outliers: {
      title: 'Unplausible Trackings (>{threshold} PT pro Item)',
      explain:
        'Stories/Bugs, bei denen mindestens eines der Felder „Σ Original Estimate", „Σ Time Spent" (Sub-Task-Aggregat) oder „Time Spent" über der Schwelle liegt. Diese Items werden in den Säulen automatisch auf 10 PT gekappt — die Tabelle hier zeigt, wo Aufräumen in JIRA hilft.',
      itemsOverThreshold: '{count} Items über Schwelle',
      emptyState:
        'Keine Items über {threshold} PT — Daten-Qualität ist im grünen Bereich (für den ganzen Snapshot).',
      emptyStateTeam:
        'Keine Items über {threshold} PT — Daten-Qualität ist im grünen Bereich (für Team „{team}").',
      subTaskAggregate:
        'Zeit über Sub-Tasks (Hauptquelle für unplausible Werte) — Σ = Sum aggregation.',
      sumRawPT: 'Σ Roh-PT: {value}',
      cappedRemoved: 'Σ Abschnitt >10 PT (durch Cap entfernt): {value} PT',
    },
    trend: {
      storiesTip1: 'Stories Created vs. Closed über die letzten 18 Monate.',
      storiesTip2: 'Δ%-Linie über 0 = mehr Stories geschlossen als created (Backlog schrumpft).',
      storiesTip3: 'Unter 0 = mehr neue Stories als geschlossen (Backlog wächst).',
      bugsTip1: 'Bugs Created vs. Closed über die letzten 18 Monate.',
      bugsTip2:
        'Δ%-Linie über 0 = mehr Bugs gefixt als gemeldet (positive Ratio), unter 0 = mehr Bugs neu.',
      priorityChip: 'Priorität: {priority}',
      deltaPctLabel: 'Δ %',
      closedDefinition:
        'Als geschlossen zählen Status: **Closed**, **Resolved**, **Aborted** — Bucket-Monat = Resolved-Timestamp. Created zählt jedes Ticket im Monat seines Created-Datums, unabhängig vom aktuellen Status.',
      createdLegend: 'Created',
      closedLegend: 'Closed',
      sumCreated: 'Σ Created',
      sumClosed: 'Σ Closed',
      deltaTotal: 'Δ% gesamt',
      infoTextStories:
        'Stories Created vs. Closed über die letzten 18 Monate (6 zurück, aktueller, 11 nach vorn).\n\nAls geschlossen zählen: Closed, Resolved, Aborted (Bucket-Monat = Resolved-Datum).\nCreated zählt jedes Ticket im Monat seines Created-Datums, unabhängig vom aktuellen Status.\n\nΔ%-Linie über 0 = mehr Stories geschlossen als created → Backlog schrumpft.\nUnter 0 = mehr neue Stories als geschlossen → Backlog wächst.',
      infoTextBugs:
        'Bugs Created vs. Closed über die letzten 18 Monate.\n\nAls geschlossen zählen: Closed, Resolved, Aborted (Bucket-Monat = Resolved-Datum).\nCreated zählt jedes Ticket im Monat seines Created-Datums, unabhängig vom aktuellen Status.\n\nΔ%-Linie über 0 = mehr Bugs gefixt als gemeldet → Qualität verbessert sich.\nUnter 0 = mehr neue Bugs als gefixt → technische Schulden wachsen.',
      footerReading:
        'Oben: Δ% = (Closed − Created) ÷ max(Created, Closed). Jeder Punkt mit Prozent-Label. Über 0 = Backlog schrumpft, unter 0 = Backlog wächst.',
      footerBars:
        'Unten: Bars zeigen die absoluten Created- und Closed-Counts pro Monat. Closed = Status Closed / Resolved / Aborted im Monat der Resolution.',
      footerTeamFiltered: 'Werte gefiltert auf Team „{team}".',
      footerAllTeams: 'Alle Teams.',
      barCreated: '{title} created',
      barClosed: '{title} closed',
      allTeamsChip: 'Alle Teams',
    },
    funnel: {
      capacity: 'Kapazität',
      capacityDesc: 'Verfügbare PT laut Kapa-Modal (Team × Monat).',
      roughPlanning: 'Grobplanung (Epic-Ebene)',
      roughPlanningDesc: 'Σ Rough + Σ Original Estimate auf Epic-Ebene.',
      refinedFull: 'Detailplanung (Refinement)',
      refinedFullDesc:
        'Vollständiger Refinement-Plan: offene + bereits abgeschlossene Items mit Original Estimate.',
      noLogBackground:
        'Hintergrund: in SchueCal loggt niemand direkt auf Story/Bug, gearbeitete Zeit landet über Sub-Task-Aggregate im Σ Time Spent.',
      outlierCapTip: 'Outlier-Cap: jedes Item zählt max. {cap} PT, um Ausreißer nicht zu verzerren.',
      releaseCompleted: 'Release abgeschlossen, alles geschafft',
      releasePastDue: 'Release-Zeitraum vorbei',
      perReleaseInfo:
        'Pro Release: Kapazität → Grobplanung → Detailplanung · Ist · mit Δ-Annotations',
      noCapacityLeg: 'Keine Kapazität gepflegt',
      capacityUnused: 'Kapazität noch nicht ausgeschöpft.',
      capacityOverbudget: 'Kapa-Budget überzogen — Re-Planning erforderlich.',
      realityExceedsRough:
        'Realität übersteigt Grob-Schätzung — Refinement lieferte mehr Aufwand als grob veranschlagt.',
      perItemHigherThanDetail:
        'Aufwand pro Item höher als Detailschätzung — Estimate war zu optimistisch.',
      barScaleInfo: 'Die Bar-Breite skaliert zur größten Stufe. Bei {release}: Kapa = {value} PT',
      dataQualityLow: '⚠️ Daten-Qualität niedrig',
      whatCounts: 'Was wird gezählt?',
      roughOverCapa:
        'Grobplanung überschreitet Kapa um {pct}% — Überbuchung, Re-Planning erwägen.',
      detailOverRough:
        'Detailplanung übersteigt Rough um {pct}% — die Epics werden teurer als grob angenommen.',
      actualOverPlan:
        'Ist überschreitet Plan rechnerisch — sollte nicht vorkommen, prüfe die Datenqualität.',
      realismCheck: 'Realismus-Check (Dreisatz, gleichmäßige Verteilung)',
    },
    months: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    health: {
      unknown: {
        headline: 'Keine Aussage möglich',
        detail: 'Release-Fenster nicht gepflegt.',
      },
      completed: {
        headline: 'Release abgeschlossen, alles geschafft',
        detail: 'Σ Plan {plan} PT komplett abgearbeitet.',
      },
      expiredOpen: {
        headline: 'Abgelaufen, Arbeit noch offen',
        detail: '{remain} PT verbleiben, aber keine Restkapa mehr.',
      },
      pastDue: {
        headline: 'Release-Zeitraum vorbei',
        detail: '{remain} PT ungelöst — Re-Planning erforderlich.',
      },
      noCapacity: {
        headline: 'Keine Kapazität gepflegt',
        detail: 'Trage im „Kapa verwalten"-Modal Werte für Team × Monat ein.',
      },
      breeze: {
        headline: 'Wird locker geschafft',
        detail: 'Restarbeit {remain} PT vs. Restkapa {capa} PT — nur {pct}% Auslastung nötig.',
      },
      doable: {
        headline: 'Sollte zu schaffen sein',
        detail: '{pct}% der Restkapa nötig. Komfortabel im Plan.',
      },
      tight: {
        headline: 'Knapp — wird kritisch',
        detail: '{pct}% der Restkapa nötig. Kein Puffer mehr.',
      },
      unrealistic: {
        headline: 'Nicht mehr realistisch',
        detail:
          'Restarbeit {remain} PT übersteigt Restkapa {capa} PT um {diff} PT — Re-Planning erforderlich.',
      },
    },
    cols: {
      kapa: 'Kapazität',
      initial: 'Säulenplanung',
      kapaSlashInitial: 'Kapazität / Säulenplanung',
      grob: 'Grobplanung (Epic-Ebene)',
      refine: 'Detailplanung (Refinement)',
      ist: 'Ist Aufwand',
      factorNote:
        'Hinweis: Story Points werden NICHT in die Berechnung einbezogen. Nur Rough Estimation und Σ Original Estimate zählen.',
      tipKapa: 'Kapazität aus „Kapa verwalten" — Team × Monat, summiert über das Release-Fenster.',
      tipInitial:
        'Säulenplanung = Initial-Plan (manuell oder automatisch = Kapa). Basis für die Grob-/Detailplanung.',
      tipKapaPlan:
        'Solange kein manueller Plan gepflegt ist, entspricht die Säulenplanung der Kapazität.',
      tipEpicGrob:
        'Pro Epic: Rough Estimation (d) + Σ Original Estimate. Grobe Vor-Refinement-Schätzung auf Epic-Ebene.',
      tipEpicGrobDate: 'Nur Items mit Created ≤ {date} (Release-Ende).',
      nRefSkippedNote: '{count} weitere Items wurden NICHT mitgezählt (Fix Version passt nicht zum Release).',
      refCapNote: 'Outlier-Cap: {count} Item(s) wurden auf {cap} PT gekappt.',
      refCapNoteNone: 'Outlier-Cap: jedes Item zählt max. {cap} PT (kein Item musste gekappt werden).',
      tipRefineStart: 'Σ „Σ Original Estimate" über {count} Items ({open} offen + {done} done).',
      tipRefineSource: 'Quelle: nur Stories/Bugs mit eigener Fix Version = {release}.',
      tipRefineStatus:
        'Status: offene Items (Backlog + In Progress etc.) + bereits abgeschlossene Items (done).',
      tipRefineTotal: '{open} Items offen + {done} Items done = {total} Σ',
      tipRefineStoriesCount: 'Stories: {count} Items',
      tipRefineBugsCount: 'Bugs: {count} Items',
      tipRefineReadHelp:
        'Lese-Hilfe: Detail ist der vollständige Plan, unabhängig davon ob im Fenster resolved.',
      istTimeWindowText: 'Resolved-Datum muss im Release-Fenster {start} → {end} liegen.',
      istTimeWindowNone: 'Kein Release-Fenster gepflegt → alle geschlossenen Items werden gezählt.',
      skippedNote:
        '{count} Items mit Fix Version „{release}" wurden NICHT mitgezählt (Resolved außerhalb Fenster).',
      noPlanNote:
        '{count} Items im Fenster hatten kein Original Estimate — Ist zählt trotzdem via Time Spent.',
      istCapNote:
        'Outlier-Cap: {estCount} Item(s) Estimate, {timeCount} Item(s) Time Spent wurden auf {cap} PT gekappt.',
      istCapNoteNone:
        'Outlier-Cap: jedes Item zählt max. {cap} PT (kein Item musste gekappt werden).',
      tipIstStart: 'Σ Ist-Aufwand über {count} geschlossene Items im Release-Fenster.',
      tipIstSource: 'Quelle: nur Stories/Bugs mit eigener Fix Version = {release}.',
      tipIstStoriesCount: 'Stories: {count} Items',
      tipIstBugsCount: 'Bugs: {count} Items',
      tipIstRelation: 'Verhältnis zum Plan-Funnel:',
      tipIstVsKapa: '{pct}% vs. Kapa ({value} PT)',
      tipIstVsRough: '{pct}% vs. Rough ({value} PT)',
      tipIstVsDetail: '{pct}% vs. Detail ({value} PT)',
      tipIstReadHelp:
        'Lese-Hilfe: <100 % der Kapa = Kapa nicht ausgeschöpft, >100 % = Überbuchung.',
      refWarn:
        'Nur {count} von {total} Items ({pct} %) haben ein Σ Original Estimate — Refinement noch dünn.',
      istWarn:
        'Nur {count} von {total} done-Items ({pct} %) haben ein Σ Original Estimate — Ist ist trotzdem via Time Spent belastbar.',
      kapaDetail1: 'Quelle: „Kapa verwalten" (Team × Monat).',
      kapaDetail2:
        'Aufteilung: gleichmäßig auf die Release-Monate; nur wenn du eine Zelle manuell änderst, weicht der Wert davon ab.',
      initialDetail1: 'Solange kein manueller Plan gepflegt ist = Kapazität.',
      initialDetail2:
        'Als Basis-Wert für Verhältnisrechnungen (z.B. Realismus-Check) besser geeignet als reine Kapa.',
      grobDetail1: 'Quelle: pro Epic Rough Estimation (d) + Σ Original Estimate.',
      grobDetail2: 'Pro Epic: eine Zahl · summiert über alle Epics dieses Releases.',
      grobDetail3: 'Status: unabhängig davon, ob das Epic done ist.',
      grobDetail4: 'Aufteilung Stories/Bugs: auf Epic-Ebene nicht bekannt.',
      refineDetail1: 'Σ Original Estimate über alle Refinement-Items dieses Releases.',
      refineDetail2: 'Status offen: Backlog, In Progress, In Review, In Test, etc.',
      refineDetail3: 'Status done: Closed, Resolved, Aborted — unabhängig vom Resolved-Datum.',
      refineDetail4: 'Nur Stories/Bugs mit eigener Fix Version = {release}.',
      refineDetail5: 'Sub-Tasks/Task/Epic werden hier NICHT gezählt.',
      refineDetail6: 'Aufteilung Stories vs. Bugs siehst du im Tooltip.',
      refineDetail7:
        'Outlier-Cap: pro Item max. {cap} PT — schützt vor einzelnen 200-PT-Ausreißern.',
      istDetail1: 'Σ (Σ Original Estimate + Σ Time Spent) / 2 über geschlossene Items im Fenster.',
      istDetail2: 'Wenn nur eins der beiden gepflegt ist: nur das gepflegte wird gezählt.',
      istDetail3: 'Status: nur done-Items (Closed, Resolved, Aborted).',
      istDetail4: 'Resolved-Datum muss im Release-Fenster liegen.',
      istDetail5: 'Nur Stories/Bugs mit eigener Fix Version = {release}.',
      istDetail6:
        'Outlier-Cap: pro Item max. {cap} PT — auch hier gilt der 30-PT-Grenzwert für die Outlier-Tabelle.',
      subLabelEpicsMixed:
        '{withBoth} Epic(s): {rough}+Est · {roughOnly} nur Rough · {estOnly} nur Est',
      subLabelResolved: '{open} offen · {done} done · {skipped} außerhalb',
      subLabelResolvedItems: '{count} Items resolved im Fenster',
      subLabelClosed: '{count} Items closed/resolved',
      subLabelNoEstimate: '{count} ohne Schätzung',
    },
  },
  en: {
    common: {
      loading: 'Loading …',
      save: 'Save',
      saving: 'Saving …',
      cancel: 'Cancel',
      close: 'Close',
      delete: 'Delete',
      apply: 'Apply',
      reset: 'Reset',
      yes: 'Yes',
      no: 'No',
      open: 'Open',
      ptSuffix: 'PD',
      itemsSuffix: 'items',
    },
    appBar: {
      title: 'SchueCal Dashboard',
      importCsv: 'Import CSV',
      releaseCalendar: 'Edit release calendar',
      capacity: 'Manage capacity',
      backup: 'Backup & restore',
      clearAll: 'Delete all issues',
      themeLight: 'Light theme',
      themeDark: 'Dark theme',
      account: 'Account',
      switchLanguage: 'Language: English',
      profile: 'Profile (coming soon)',
      logout: 'Sign out',
      roleAdmin: 'Administrator',
      roleUser: 'User',
      confirmClearAll:
        'Really delete all loaded issues and meta data? Capacity, release calendar etc. will be kept.',
    },
    sections: {
      filters: {
        title: 'Team filter & SP→PD factor',
        subtitle:
          'Global team filter (applies to all cards below) and story-point converter. Currently: SP is not included in the calculation.',
      },
      stats: {
        title: 'Counts: epics · stories · bugs',
        subtitle:
          'Number of issue types matching the current filters. Reacts to team and global filters.',
      },
      status: {
        title: 'Status distribution',
        subtitle:
          'JIRA workflow status of stories and bugs. Required statuses are always shown, even when count = 0.',
      },
      timeline: {
        title: 'Timeline & release calendar',
        subtitle:
          '18-month axis with release bands, service-pack phases and SP markers. Created/resolved trend per month.',
      },
      trend: {
        title: 'Ticket trend (stories + bugs)',
        subtitle:
          'Two charts per type: created vs. resolved across the months, with Δ% trend line. Filter-aware.',
      },
      columns: {
        title: 'Column planning per release',
        subtitle:
          'Five columns: capacity → initial plan → rough plan → detailed plan → actual effort. Editable via modals.',
      },
      funnel: {
        title: 'Funnel + realism check',
        subtitle:
          'Per release: plan funnel with Δ annotations and traffic-light rating (remaining capacity vs. remaining work).',
      },
      outliers: {
        title: 'Data quality: implausible trackings',
        subtitle:
          'Stories/bugs with estimate or Σ time spent above 30 PD. In the columns these items are capped at 10 PD — the table shows the originals for JIRA maintenance.',
      },
      duplicates: {
        title: 'Data quality: possible duplicates',
        subtitle:
          'Lexically similar stories/bugs per team — open items + done from the last 6 months. Pre-filter: same team + issue type. With direct link to JIRA.',
      },
      burnup: {
        title: 'Refinement burn-up (across imports)',
        subtitle:
          'Line chart across the history snapshots: open/closed counts, closure rate, plan-vs-refined burn-up. With team selector.',
      },
      drift: {
        title: 'Epic drift & confidence',
        subtitle:
          'Table: per epic the drift between rough and refined, refinement progress, confidence score. Sortable.',
      },
      epics: {
        title: 'Epics table with child items',
        subtitle:
          'All epics expandable with stories/bugs. Plan/actual values per item. Filter-aware.',
      },
      deps: {
        title: 'Ticket dependencies',
        subtitle:
          'Blocked, blocking, related — broken down by target team. Priority: Tools and Features. "is blocked by" is the most critical class.',
      },
      customerBugs: {
        title: 'Bugs: customer vs. internal',
        subtitle:
          'Bugs split by origin. Customer bug = ticket with CPS link (custom field "CPS Ticket ID"). Internal = no CPS reference.',
      },
      releaseTickets: {
        title: 'Tickets per release / service pack',
        subtitle:
          'Pick a Fix Version (e.g. "2026 R1 SP03") and see all tickets in it. Default: only closed. Team filter above applies too.',
      },
      sprint: {
        title: 'Sprint analysis',
        subtitle:
          'Pick any date range (default 3 weeks). Counts tickets with status = done whose resolved date falls in the range. Breakdown by issue type, team, CPS and carry-over.',
      },
      expectedBehaviour: {
        title: 'Expected Behaviour: quality overview',
        subtitle:
          'Is the field filled? Which language? Verbose or too short? Coverage per team and issue type, language distribution, quality buckets by text length.',
      },
      checklist: {
        title: 'Checklist / Acceptance Criteria',
        subtitle:
          'Evaluates the JIRA field "Checklist Text": coverage, "# Acceptance Criteria" header, completed vs. open items per ticket. Excel export with JIRA links.',
      },
      search: {
        title: 'Full-text search across all tickets',
        subtitle:
          'Search in Summary, Expected Behaviour, Parent Summary, Labels and more. Case-sensitive and regex available. Works with team filter and status scope.',
      },
      clusters: {
        title: 'Clusters: profiles · fittings · series',
        subtitle:
          '3-level classification from labels (Klinkung/Verglasung/…) and Summary prefix (AWS 75, Janisol Arte 2.0, …). A ticket can end up in multiple clusters.',
      },
    },
    login: {
      title: 'SchueCal Dashboard',
      subtitle: 'Please sign in',
      username: 'Username',
      password: 'Password',
      submit: 'Sign in',
      submitting: 'Signing in …',
      errorFallback: 'Login failed',
    },
    filters: {
      searchPlaceholder: 'Search by key, summary, assignee, team …',
      status: 'Status',
      assignee: 'Assignee',
      priority: 'Priority',
      reset: 'Reset filters',
    },
    teamBar: {
      label: 'Team filter',
      allTeams: 'All teams ({count})',
      otherTeams: 'Other teams',
      spToPtLabel: '1 SP =',
    },
    stats: {
      epics: 'Epics',
      stories: 'Stories',
      bugs: 'Bugs',
    },
    statusBreakdown: {
      title: 'Status distribution',
      subtitle: '{count} stories + bugs by JIRA workflow',
    },
    banner: {
      noSnapshotTitle: 'No JIRA snapshot loaded',
      noSnapshotBody:
        'Click **Import CSV** in the top right and upload a JIRA export. Multi-selection is possible — to bypass JIRA\'s 10,000 issue export limit, export per team (see the export note after the import).',
      filteredTitle: 'Filtered view: {filtered} of {total} issues',
      loadedTitle: 'JIRA snapshot loaded',
      issues: '{count} issues',
      teamPrefix: 'Team',
      statusPrefix: 'Status',
      assigneePrefix: 'Assignee',
      priorityPrefix: 'Priority',
      searchPrefix: 'Search',
      mergedCsvs: '{count} CSVs merged',
      importedAt: 'As of: {date}',
      hideExportNote: 'Hide export note',
      showExportNote: 'How were the CSVs exported?',
      exportConvTitle: 'Export convention — one CSV per team',
      exportConvBody:
        'JIRA allows a maximum of **10,000 issues** per CSV export. The total SchueCal inventory is currently **{count}** issues — so we export per team and merge on import here (dedup by `Issue key`).',
      exportConvJql: 'Per team: JQL filter + Export → CSV (All fields)',
      exportConvHint:
        '• **JIRA UI**: Issues → Search → enter JQL → *… (3-dot menu)* → **Export** → **CSV (All fields)**.\n• Required columns in the export: `Issue Type`, `Issue key`, `Summary`, `Status`, `Team Name`, `Parent key`, `Fix versions`, `Affects Version/s`, `Σ Original Estimate`, `Σ Time Spent`, `Custom field (Rough Estimation (d))`, `Created`, `Resolved`.\n• Upload multiple files in the CSV import dialog at once — they are deduplicated via `Issue key`. Duplicates (e.g. an item split across two teams) are consolidated automatically.',
    },
    import: {
      title: 'Import CSV',
      dropzone: 'Drop CSV files here or click',
      dropzoneHint: 'Multi-select allowed · Dedup by "Issue key"',
      modeQuestion: 'How to process?',
      modeReplace: 'Replace (Recommended)',
      modeReplaceHint: 'Replace existing issues with the new ones — clean snapshot.',
      modeMerge: 'Add / merge',
      modeMergeHint: 'Merge existing + new, same issue keys are overwritten (team splits).',
      close: 'Close',
      importBtn: 'Import ({count})',
      importing: 'Importing …',
      verbReplaced: 'replaced by',
      verbMerged: 'merged to',
      resultTemplate: 'Issues {verb} {count} net',
    },
    releaseCal: {
      title: 'Release calendar',
      subtitle: 'Start/end per release · service packs per release',
      empty: 'No releases yet. Create the first one below.',
      delRelease: 'Delete release',
      startLabel: 'Start',
      endLabel: 'End',
      servicePacks: 'Service packs ({count})',
      addSp: 'Add SP',
      removeSp: 'Remove SP',
      releaseNamePh: 'e.g. 2028 R1',
      addRelease: 'Release',
      confirmDelete: 'Really delete release "{name}"? All service packs will be removed as well.',
      errNeedDates: '"{name}" needs a start and end date.',
      errStartAfterEnd: '"{name}": start ({start}) is after end ({end}).',
      errSpMissing: '"{name}" has an SP without name or date.',
    },
    capacity: {
      title: 'Manage capacity',
      subtitle: 'Person-days per team × release × month (separate stories / bugs)',
      quickFill: 'Quick-fill value',
      apply: 'Apply',
      manual: 'Manual',
      auto: 'Automatic',
      save: 'Save',
      saving: 'Saving …',
      close: 'Close',
      teamLabel: 'Team',
      releaseLabel: 'Release',
      noTeams: 'No teams in the data',
      pickTeamHint: 'Pick a team above to maintain capacity.',
      monthHeader: 'Month',
      storiesLabel: 'Stories',
      bugsLabel: 'Bugs',
      sumFor: 'Σ for {team} · {release}:',
      storiesChip: 'Stories {value} PD',
      bugsChip: 'Bugs {value} PD',
      totalChip: 'Total {value} PD',
      fillStories: '→ Stories',
      fillBugs: '→ Bugs',
      fillBoth: '→ S+B',
    },
    backup: {
      title: 'Backup & restore',
      subtitle: 'JSON snapshot of all data · take your state to another machine',
      exportCardTitle: 'Back up',
      exportCardBody: 'Complete JSON file with the entire current state (issues + configuration).',
      countIssues: '{count} issues',
      countReleases: '{count} release(s)',
      countTeamsCapa: '{count} team(s) capa',
      countInitialPlans: '{count} initial plan(s)',
      download: 'Download backup',
      restoreCardTitle: 'Restore',
      restoreCardBody:
        'Upload a JSON backup. You\'ll be asked whether to replace or merge with the current state.',
      dropzone: 'Drop JSON backup here or click',
      dropzoneHint: 'One file only',
      fileMeta: '{size} · exported on {date}',
      modeQuestion: 'How to process?',
      modeReplace: 'Replace (Recommended)',
      modeReplaceHint: 'Discard existing data, take over the backup state completely.',
      modeMerge: 'Merge',
      modeMergeHint: 'Merge issues (same issue keys are overwritten). Configuration is merged too.',
      close: 'Close',
      replace: 'Replace',
      merge: 'Merge',
      restoring: 'Restoring …',
      restoreOk: 'Restore successful. {issues} issues, {releases} release(s) now active.',
    },
    releaseBlocks: {
      title: 'Column planning',
      subtitle:
        '{count} release(s) · capacity · column planning · rough plan · detailed plan · actual',
      releaseCalBtn: 'Release calendar',
      capacityBtn: 'Manage capacity',
      noDateSet: 'Date not yet set',
      itemsSummary: '{epics} epic(s) · {stories} stories · {bugs} bugs',
      planChip: 'Plan {value} PD',
      actualChip: 'Actual {value} PD',
      capacityChip: 'Capacity {value} · utilization {pct}%',
      noCapacityChip: 'No capacity set',
    },
    epicDrift: {
      tooltipHead:
        'Per epic: how far does the detailed plan (Σ Original Estimate of refinements) diverge from the rough plan (Rough)?',
      empty: 'No epics in this selection. Open filters further or pick a different release.',
      driftExplain:
        'Drift = Σ refined child items − rough · only counts child items whose Fix Version belongs to the same release.',
      epicsOtherRelease:
        '{count} filtered epics belong to a different release or have no release assignment.',
      confExplain:
        'Confidence = mean of "% refined" and "% with SP set". Sort descending to find candidates for the next refinement.',
    },
    epicsTable: {
      title: 'Epics & stories/bugs',
      subtitle: '{epics} epic(s) · {kids} child items',
      expandAll: 'Expand all',
      collapseAll: 'Collapse all',
      colType: 'Type',
      colKey: 'Key',
      colSummary: 'Summary',
      colStatus: 'Status',
      colAssignee: 'Assignee',
      colTeam: 'Team',
      priority: 'Priority',
      colRough: 'Rough',
      colSp: 'SP',
      colEstimate: 'Estimate',
      colPlan: 'Plan (PD)',
      colActual: 'Actual (PD)',
      colKids: 'Child items',
    },
    outliers: {
      title: 'Implausible trackings (>{threshold} PD per item)',
      explain:
        'Stories/bugs where at least one of the fields "Σ Original Estimate", "Σ Time Spent" (sub-task aggregate) or "Time Spent" is above the threshold. These items are automatically capped at 10 PD in the columns — the table here shows where clean-up in JIRA helps.',
      itemsOverThreshold: '{count} items over threshold',
      emptyState:
        'No items above {threshold} PD — data quality is in the green zone (for the whole snapshot).',
      emptyStateTeam:
        'No items above {threshold} PD — data quality is in the green zone (for team "{team}").',
      subTaskAggregate:
        'Time via sub-tasks (main source of implausible values) — Σ = sum aggregation.',
      sumRawPT: 'Σ raw PD: {value}',
      cappedRemoved: 'Σ portion >10 PD (removed by cap): {value} PD',
    },
    trend: {
      storiesTip1: 'Stories created vs. closed over the last 18 months.',
      storiesTip2: 'Δ% line above 0 = more stories closed than created (backlog shrinks).',
      storiesTip3: 'Below 0 = more new stories than closed (backlog grows).',
      bugsTip1: 'Bugs created vs. closed over the last 18 months.',
      bugsTip2:
        'Δ% line above 0 = more bugs fixed than reported (positive ratio), below 0 = more new bugs.',
      priorityChip: 'Priority: {priority}',
      deltaPctLabel: 'Δ %',
      closedDefinition:
        'Counted as closed (statuses): **Closed**, **Resolved**, **Aborted** — bucket month = Resolved timestamp. Created counts every ticket in the month of its Created date, regardless of current status.',
      createdLegend: 'Created',
      closedLegend: 'Closed',
      sumCreated: 'Σ Created',
      sumClosed: 'Σ Closed',
      deltaTotal: 'Δ% total',
      infoTextStories:
        'Stories created vs. closed over the last 18 months (6 back, current, 11 forward).\n\nCounted as closed: Closed, Resolved, Aborted (bucket month = Resolved date).\nCreated counts every ticket in the month of its Created date, regardless of current status.\n\nΔ% line above 0 = more stories closed than created → backlog shrinks.\nBelow 0 = more new stories than closed → backlog grows.',
      infoTextBugs:
        'Bugs created vs. closed over the last 18 months.\n\nCounted as closed: Closed, Resolved, Aborted (bucket month = Resolved date).\nCreated counts every ticket in the month of its Created date, regardless of current status.\n\nΔ% line above 0 = more bugs fixed than reported → quality improves.\nBelow 0 = more new bugs than fixed → tech debt grows.',
      footerReading:
        'Top: Δ% = (Closed − Created) ÷ max(Created, Closed). Every point with percentage label. Above 0 = backlog shrinks, below 0 = backlog grows.',
      footerBars:
        'Bottom: Bars show absolute Created and Closed counts per month. Closed = status Closed / Resolved / Aborted in the month of resolution.',
      footerTeamFiltered: 'Values filtered to team "{team}".',
      footerAllTeams: 'All teams.',
      barCreated: '{title} created',
      barClosed: '{title} closed',
      allTeamsChip: 'All teams',
    },
    funnel: {
      capacity: 'Capacity',
      capacityDesc: 'Available PD per capacity modal (team × month).',
      roughPlanning: 'Rough plan (epic level)',
      roughPlanningDesc: 'Σ rough + Σ original estimate at epic level.',
      refinedFull: 'Detailed plan (refinement)',
      refinedFullDesc:
        'Complete refinement plan: open + already completed items with original estimate.',
      noLogBackground:
        'Background: in SchueCal nobody logs directly on story/bug, worked time lands in Σ time spent via sub-task aggregates.',
      outlierCapTip:
        'Outlier cap: each item counts max. {cap} PD to keep outliers from skewing the picture.',
      releaseCompleted: 'Release completed, everything shipped',
      releasePastDue: 'Release period past due',
      perReleaseInfo:
        'Per release: capacity → rough plan → detailed plan · actual · with Δ annotations',
      noCapacityLeg: 'No capacity set',
      capacityUnused: 'Capacity not yet used up.',
      capacityOverbudget: 'Capacity budget exceeded — replanning required.',
      realityExceedsRough:
        'Reality exceeds rough estimate — refinement delivered more effort than roughly estimated.',
      perItemHigherThanDetail:
        'Effort per item higher than detailed estimate — estimate was too optimistic.',
      barScaleInfo: 'Bar width scales to the largest stage. At {release}: capa = {value} PD',
      dataQualityLow: '⚠️ Data quality low',
      whatCounts: 'What is counted?',
      roughOverCapa: 'Rough plan exceeds capa by {pct}% — overbooking, consider replanning.',
      detailOverRough:
        'Detailed plan exceeds rough by {pct}% — the epics turn out more expensive than roughly assumed.',
      actualOverPlan:
        'Actual exceeds plan arithmetically — should not happen, check data quality.',
      realismCheck: 'Realism check (rule of three, even distribution)',
    },
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    health: {
      unknown: {
        headline: 'No assessment possible',
        detail: 'Release window not set.',
      },
      completed: {
        headline: 'Release completed, everything shipped',
        detail: 'Σ plan {plan} PD fully processed.',
      },
      expiredOpen: {
        headline: 'Expired, work still open',
        detail: '{remain} PD remaining, but no capacity left.',
      },
      pastDue: {
        headline: 'Release period past due',
        detail: '{remain} PD unresolved — replanning required.',
      },
      noCapacity: {
        headline: 'No capacity set',
        detail: 'Enter values for team × month in the "Manage capacity" modal.',
      },
      breeze: {
        headline: 'Easy',
        detail: 'Remaining work {remain} PD vs. remaining capa {capa} PD — only {pct}% utilization needed.',
      },
      doable: {
        headline: 'Should be doable',
        detail: '{pct}% of remaining capa needed. Comfortably on plan.',
      },
      tight: {
        headline: 'Tight — getting critical',
        detail: '{pct}% of remaining capa needed. No buffer left.',
      },
      unrealistic: {
        headline: 'No longer realistic',
        detail:
          'Remaining work {remain} PD exceeds remaining capa {capa} PD by {diff} PD — replanning required.',
      },
    },
    cols: {
      kapa: 'Capacity',
      initial: 'Column plan',
      kapaSlashInitial: 'Capacity / column plan',
      grob: 'Rough plan (epic level)',
      refine: 'Detailed plan (refinement)',
      ist: 'Actual effort',
      factorNote:
        'Note: story points are NOT included in the calculation. Only rough estimation and Σ original estimate count.',
      tipKapa: 'Capacity from "Manage capacity" — team × month, summed over the release window.',
      tipInitial:
        'Column plan = initial plan (manual or automatic = capa). Baseline for rough/detailed plan.',
      tipKapaPlan:
        'As long as no manual plan is set, the column plan equals the capacity.',
      tipEpicGrob:
        'Per epic: rough estimation (d) + Σ original estimate. Rough pre-refinement estimate at epic level.',
      tipEpicGrobDate: 'Only items with created ≤ {date} (release end).',
      nRefSkippedNote:
        '{count} further items were NOT counted (Fix Version does not match the release).',
      refCapNote: 'Outlier cap: {count} item(s) were capped at {cap} PD.',
      refCapNoteNone:
        'Outlier cap: each item counts max. {cap} PD (no item had to be capped).',
      tipRefineStart: 'Σ "Σ original estimate" over {count} items ({open} open + {done} done).',
      tipRefineSource: 'Source: only stories/bugs with own Fix Version = {release}.',
      tipRefineStatus:
        'Status: open items (backlog + in progress etc.) + already completed items (done).',
      tipRefineTotal: '{open} items open + {done} items done = {total} Σ',
      tipRefineStoriesCount: 'Stories: {count} items',
      tipRefineBugsCount: 'Bugs: {count} items',
      tipRefineReadHelp:
        'Reading aid: detail is the full plan, regardless of whether resolved in the window.',
      istTimeWindowText: 'Resolved date must be within the release window {start} → {end}.',
      istTimeWindowNone: 'No release window set → all closed items are counted.',
      skippedNote:
        '{count} items with Fix Version "{release}" were NOT counted (resolved outside the window).',
      noPlanNote:
        '{count} items in the window had no original estimate — actual counts via time spent anyway.',
      istCapNote:
        'Outlier cap: {estCount} item(s) estimate, {timeCount} item(s) time spent were capped at {cap} PD.',
      istCapNoteNone:
        'Outlier cap: each item counts max. {cap} PD (no item had to be capped).',
      tipIstStart: 'Σ actual effort over {count} closed items in the release window.',
      tipIstSource: 'Source: only stories/bugs with own Fix Version = {release}.',
      tipIstStoriesCount: 'Stories: {count} items',
      tipIstBugsCount: 'Bugs: {count} items',
      tipIstRelation: 'Ratio to plan funnel:',
      tipIstVsKapa: '{pct}% vs. capa ({value} PD)',
      tipIstVsRough: '{pct}% vs. rough ({value} PD)',
      tipIstVsDetail: '{pct}% vs. detail ({value} PD)',
      tipIstReadHelp:
        'Reading aid: <100% of capa = capa not used up, >100% = overbooking.',
      refWarn:
        'Only {count} of {total} items ({pct}%) have a Σ original estimate — refinement still thin.',
      istWarn:
        'Only {count} of {total} done items ({pct}%) have a Σ original estimate — actual is nonetheless robust via time spent.',
      kapaDetail1: 'Source: "Manage capacity" (team × month).',
      kapaDetail2:
        'Distribution: evenly across the release months; only when you manually change a cell does the value deviate.',
      initialDetail1: 'As long as no manual plan is set = capacity.',
      initialDetail2:
        'Better suited as a baseline for ratio calculations (e.g. realism check) than raw capa.',
      grobDetail1: 'Source: per epic rough estimation (d) + Σ original estimate.',
      grobDetail2: 'Per epic: one number · summed over all epics of this release.',
      grobDetail3: 'Status: independent of whether the epic is done.',
      grobDetail4: 'Split stories/bugs: not known at epic level.',
      refineDetail1: 'Σ original estimate over all refinement items of this release.',
      refineDetail2: 'Status open: backlog, in progress, in review, in test, etc.',
      refineDetail3: 'Status done: closed, resolved, aborted — regardless of resolved date.',
      refineDetail4: 'Only stories/bugs with own Fix Version = {release}.',
      refineDetail5: 'Sub-tasks/task/epic are NOT counted here.',
      refineDetail6: 'You can see the split stories vs. bugs in the tooltip.',
      refineDetail7:
        'Outlier cap: max. {cap} PD per item — protects against isolated 200-PD outliers.',
      istDetail1: 'Σ (Σ original estimate + Σ time spent) / 2 over closed items in the window.',
      istDetail2: 'If only one of the two is set: only the set one is counted.',
      istDetail3: 'Status: only done items (closed, resolved, aborted).',
      istDetail4: 'Resolved date must fall within the release window.',
      istDetail5: 'Only stories/bugs with own Fix Version = {release}.',
      istDetail6:
        'Outlier cap: max. {cap} PD per item — the 30-PD limit for the outlier table also applies here.',
      subLabelEpicsMixed:
        '{withBoth} epic(s): {rough}+est · {roughOnly} only rough · {estOnly} only est',
      subLabelResolved: '{open} open · {done} done · {skipped} outside',
      subLabelResolvedItems: '{count} items resolved in the window',
      subLabelClosed: '{count} items closed/resolved',
      subLabelNoEstimate: '{count} without estimate',
    },
  },
};
